import { Injectable } from '@angular/core';
import { CammsClientStorageService } from 'projects/camms-client-storage/src/public-api';

@Injectable({
    providedIn: 'root',
})
export class CammsNavigateHubService {
    constructor(private storageService: CammsClientStorageService) {}

    getAuthToken(isTokenEncrypted = true): string[] {
        const tokenArr: string[] = [];
        // Get queue from the local storage
        const storedTokenQueue =
            JSON.parse(localStorage.getItem('queuedTokenList')!) || [];
        if (storedTokenQueue.length > 0) {
            const noOfTokens = 1;

            for (let i = 0; i < noOfTokens; i++) {
                tokenArr.push(
                    this.getRandomToken(storedTokenQueue, isTokenEncrypted),
                );
            }
            localStorage.setItem(
                'queuedTokenList',
                JSON.stringify(storedTokenQueue),
            );
        }
        return tokenArr;
    }

    getRandomToken(array, isTokenEncrypted): string {
        var index = Math.floor(Math.random() * array.length);

        var item = array[index]; // Log the item
        array.splice(index, 1); // Remove the item from the array

        return isTokenEncrypted
            ? item
            : this.storageService.getDecryptedValue(item);
    }

    getAccessToken(): string {
        return (
            this.storageService.getData('accessToken') ??
            'TOKEN_IS_NOT_AVAILABLE'
        );
    }
}
